import {Component, OnInit, Inject, NgZone} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'md-clu-agent-settings-devices-dialog',
    templateUrl: './md-clu-agent-settings-devices-dialog.component.html'
})
export class MdCluAgentSettingsDevicesDialogComponent implements OnInit {
    constructor(
        private ngZone: NgZone,
        private matDialogRef: MatDialogRef<MdCluAgentSettingsDevicesDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        
    }

    ngOnInit() {
        this.matDialogRef.keydownEvents().subscribe(event => { if (event.key === "Escape") { this.close(); } });
    }
    
    close() {
        this.ngZone.run(() => { this.matDialogRef.close(false); });
    }
}